module.exports = __webpack_public_path__ + "img/29_33.f3933076.png";